
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-indigo-100 to-violet-50 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
            <h1>
              <span className="block text-base font-semibold text-ai-purple tracking-wide uppercase">AI Nexus</span>
              <span className="mt-1 block text-4xl tracking-tight font-extrabold sm:text-5xl xl:text-6xl">
                <span className="block text-gray-900">The Future of AI</span>
                <span className="block bg-gradient-to-r from-ai-indigo to-ai-purple bg-clip-text text-transparent">
                  Starts Here
                </span>
              </span>
            </h1>
            <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
              Discover cutting-edge AI insights, trends, and innovations. Join our community of tech enthusiasts, researchers, and industry professionals.
            </p>
            <div className="mt-8 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0">
              <div className="flex flex-col sm:flex-row sm:justify-center lg:justify-start gap-4">
                <Button
                  className="bg-gradient-to-r from-ai-indigo to-ai-purple text-white hover:from-ai-indigo hover:to-ai-purple hover:opacity-90"
                  asChild
                >
                  <Link to="/signup">Get Started</Link>
                </Button>
                <Button
                  variant="outline"
                  className="border-ai-indigo text-ai-indigo hover:bg-ai-indigo/10"
                  asChild
                >
                  <Link to="/about">Learn More</Link>
                </Button>
              </div>
            </div>
          </div>
          <div className="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
            <div className="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md">
              <div className="relative block w-full bg-white rounded-lg overflow-hidden">
                <img
                  className="w-full"
                  src="https://images.unsplash.com/photo-1498050108023-c5249f4df085"
                  alt="Modern workspace with laptop showing code"
                />
                <div className="absolute inset-0 bg-gradient-to-br from-ai-indigo/30 to-ai-purple/30 mix-blend-multiply" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
